export const AVATAR_LIST = ["🤠", "👽", "🤖", "🦄", "🐶", "🐱", "🐼", "🐯", "🦸", "🥷", "🧙‍♀️", "🧛‍♂️", "👦", "👧", "🧜‍♀️", "👩‍🏫"];

export function getAvatarById(id) {
  return AVATAR_LIST[id] || '🤠';
}
